import React from "react";
import Select from "react-select";
import { SeasonPassFieldLabel } from "../../SeasonPassFieldLabel";
import { SelectedTickets } from "../SelectedTickets";

import { paymentMethodOptions as defaultOptions } from "../../constants";

import "../PartizanOpenSelling.sass";

export const ChoosePaymentMethod = ({
  tickets,
  total,
  buyerEmail,
  handleRepaetEmailChange,
  reapetedBuyerEmail,
  paymentMethod,
  email,
  hasSeats,
  feeRate,
  currency,
  paymentMethodLabel = "Contact details",
  paymentMethodOptions = defaultOptions,
  handleChange = () => {},
}) => {
  const isEmailsNoMatch =
    reapetedBuyerEmail && reapetedBuyerEmail !== buyerEmail;

  const handleClick = () => {
    handleChange("buyerEmail", reapetedBuyerEmail);
  };

  return (
    <div className="partizan-open-selling__step">
      <div className="partizan-open-selling__step-hero">
        <h4 className="partizan-open-selling__text-bold">Ticket receipt</h4>
        <p
          style={{ marginBottom: "20px" }}
          className="partizan-open-selling__text-normal-small"
        >
          You will receive tickets at{" "}
          <span className="partizan-open-selling__text-bold-small">
            {email}
          </span>
        </p>

        <SeasonPassFieldLabel
          shouldWrapInLabel={false}
          label="Please repeat your email address"
          isRequired={!reapetedBuyerEmail}
        >
          <div
            style={{ marginBottom: "10px" }}
            className="partizan-open-selling__fields-group"
          >
            <input
              className="seasonpass__field-input"
              placeholder="Enter your email"
              onChange={(e) => handleRepaetEmailChange(e.target.value)}
              type="text"
            />
            {isEmailsNoMatch && (
              <button onClick={handleClick} className="btn-primary">
                Use this email
              </button>
            )}
          </div>

          {isEmailsNoMatch && (
            <span className="partizan-open-selling__text-normal-small partizan-open-selling__text-error">
              The entered email address does not match the one previously
              provided. Please enter a correct email address.
            </span>
          )}
        </SeasonPassFieldLabel>

        <SeasonPassFieldLabel
          label={paymentMethodLabel}
          isRequired={!paymentMethod}
          className="partizan-open-selling__payment-method"
        >
          <Select
            options={paymentMethodOptions}
            name="paymentMethod"
            value={paymentMethodOptions.find(
              ({ value }) => paymentMethod === value
            )}
            onChange={(value) => handleChange("paymentMethod", value.value)}
            classNamePrefix="partizan-open-selling__select"
            className="partizan-open-selling__select"
          />
        </SeasonPassFieldLabel>
      </div>
      <div className="partizan-open-selling__step-info">
        <SelectedTickets
          tickets={tickets}
          feeRate={feeRate}
          hasSeats={hasSeats}
          currency={currency}
          total={total}
        />
      </div>
    </div>
  );
};
